module.exports = __webpack_public_path__ + "img/1W4DEvWijeQUR7R15bAq7U1jSlHEImrTB.cf3dba81.jpg";